@if (processKeys().length) {
  <span class="config-links" (click)="$event.stopPropagation()">
    @for (key of processKeys(); track key) {
      <a [routerLink]="['/admin/orchestration/processes', key]">{{ key }}</a>
    }
  </span>
}
@if (configs().length) {
  <span class="config-links">
    <span class="config-links__label">{{ 'Command configuration' | translate }}</span>
    @for (config of configs(); track config.sectionName) {
      <a [routerLink]="['/admin/orchestration/command-config', config.sectionName]">{{ config.labelKey | translate }}</a>
    }
  </span>
}
